import { render, staticRenderFns } from "./LabelPicker.vue?vue&type=template&id=fc9bec58&"
import script from "./LabelPicker.vue?vue&type=script&lang=ts&"
export * from "./LabelPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports